import styled from '@emotion/styled/macro';
import { InfiniteScrollDataTable, Variables } from '@enter/core';
import {
    TableContainer as DataTableContainer,
    TableHeader as DataTableHeader,
} from '@enter/core/src/ui/data-table/infinite-scroll-data-table.styles';

export const ListContainer = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
`;

export const TableCard = styled.div`
    background: ${Variables.Swatches.White};
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const HeaderActions = styled.div`
    display: flex;
    gap: 8px;
`;

export const PayersTable = styled(InfiniteScrollDataTable)`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;

    /* Remove divider line between custom toolbar and table */
    ${DataTableContainer} {
        box-shadow: none;
        border: none;
    }

    ${DataTableHeader} {
        border: none !important;
        border-bottom: 1px solid #e2e8f0 !important;
    }
`;

export const TableHeaderSection = styled.div`
    padding: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
    background-color: ${Variables.Colors.ghostWhite};
`;

export const ToolbarActions = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
`;

export const InfoPanel = styled.div`
    min-width: 450px;
    max-width: 580px;
    padding: 12px;
`;

export const InfoTitle = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: ${Variables.Colors.n70};
    margin-bottom: 8px;
`;

export const InfoRow = styled.div`
    display: grid;
    grid-template-columns: 110px 1fr;
    gap: 8px;
    padding: 4px 0;
`;

export const InfoLabel = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n50};
`;

export const InfoValue = styled.div`
    font-size: 16px;
    color: ${Variables.Colors.n70};
    overflow-wrap: anywhere;
`;
